module.exports = __webpack_public_path__ + "static/media/home.9ccbe979.svg";